export const QA_NAME_CALENDAR_GRID_PREV = 'calendarGridPrev'

export const QA_NAME_CALENDAR_GRID_TODAY = 'calendarGridToday'

export const QA_NAME_CALENDAR_GRID_NEXT = 'calendarGridNext'

export const QA_NAME_CALENDAR_GRID_RANGE = 'calendarGridRange'
